import { createListCollection, ListCollection } from "@ark-ui/react";

import {
  TabItem,
  Tabs,
} from "@/features/widget-forms/forms/weather-model-map/components/tabs";
import type { IconNames } from "@/components/icon/icon";

export type MapWidgetTabRailItem = {
  value: string;
  label: string;
  icon?: IconNames;
};

type MapWidgetTabRailProps = {
  items: MapWidgetTabRailItem[];
  value: string;
  onValueChange: (value: string) => void;
  /** Rail direction; defaults to a vertical (left) rail. */
  orientation?: "vertical" | "horizontal";
  /** Trigger visual style; only meaningful for the horizontal rail. */
  variant?: "tabs" | "rail";
};

export function MapWidgetTabRail({
  items,
  value,
  onValueChange,
  orientation = "vertical",
  variant = "tabs",
}: MapWidgetTabRailProps) {
  const collection: ListCollection<TabItem> = createListCollection({
    items: items.map((i) => ({
      label: i.label,
      value: i.value,
      icon: i.icon,
    })) as TabItem[],
  });
  return (
    <Tabs
      orientation={orientation}
      variant={variant}
      collection={collection}
      value={value}
      onValueChange={(e) => onValueChange(e.value as string)}
    />
  );
}
